var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tile is-child is-warning notification",on:{"click":_vm.onClickPG}},[_c('p',{staticClass:"title"},[_vm._v("\n    From $"+_vm._s(_vm.minPrice)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('icon-segments',{attrs:{"permutation":this.permutation}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e00b1606","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PermutationGroup.vue
// module id = null
// module chunks = 